import { render, staticRenderFns } from "./compareKecelakaanDiri.vue?vue&type=template&id=619a9280&"
import script from "./compareKecelakaanDiri.vue?vue&type=script&lang=ts&"
export * from "./compareKecelakaanDiri.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports